export default __webpack_public_path__ + "93a2ddbcb063f19df7ca616baf8ea5a6.png";